import React, { useContext, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { GENERATE_TIPALTI_IFRAME_URL } from '../../../graphql/mutations';
import { GenerateTipaltiIframeUrlDataType } from '../../../types';
import Spinner from '../../../components/Spinner';
import { captureException } from '../../../utils/error';
import { TipaltiIframe } from './styles';
import { InspectorDashboardContext } from '../context';
import Button from '../../../components/Button';
import { DashboardPageTab } from '../types';
import './styles.scss';

interface Props {
  iframeType: 'setup_process' | 'invoice_history' | 'payment_history',
  showBackToChecklist: boolean,
}

const TipaltiIframeLoader: React.FC<Props> = ({ iframeType, showBackToChecklist }) => {
  const { state, setPage } = useContext(InspectorDashboardContext);

  const [
    generateTipaltiIframeUrl, { loading, error, data: tipaltiIframeData },
  ] = useMutation<GenerateTipaltiIframeUrlDataType>(
    GENERATE_TIPALTI_IFRAME_URL,
  );

  useEffect(() => {
    generateTipaltiIframeUrl({
      variables: {
        input: { contractorId: state.contractor.id, iframeType },
      },
    });
  }, [iframeType]);

  useEffect(() => {
    if (error) {
      captureException(error);
    }
  }, [error]);

  return (
    <div className="tipaltiIframeContainer">
      <div className="tipaltiIframeContainer__header">
        <div className="userFormContainer__header__text">
          {iframeType === 'setup_process' ? 'Payment setup' : 'Payment history'}
        </div>
        {showBackToChecklist && (
          <div className="buttonContainer">
            <Button onClick={() => setPage(DashboardPageTab.Jobs)}>Back to checklist</Button>
          </div>
        )}
      </div>
      {iframeType === 'setup_process' && (
        <div className="tipaltiIframeContainer__content">
          Payments will be issued a business day after a report is uploaded.&nbsp;
          It can take an additional 1-3 business days to process the payment depending on your bank.
        </div>
      )}
      {loading && (<Spinner />)}
      {error && (
        <div>
          There was an issue accessing the payment system.
          Please try again or contact customer service for support.
        </div>
      )}
      {tipaltiIframeData?.generateTipaltiIframeUrl?.iframeUrl && (
        <TipaltiIframe title="Tipalti" src={tipaltiIframeData.generateTipaltiIframeUrl.iframeUrl} />
      )}
    </div>
  );
};

export default TipaltiIframeLoader;
